/**
 * TipoRelatorio - Enumeração para tipos de relatório
 * @readonly
 * @enum {Object}
 */
class TipoRelatorio {
    static SISTEMA = "SISTEMA";
    static CLIENTE = "CLIENTE";
    static AUDITORIA = "AUDITORIA";
}

export { TipoRelatorio };